"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('arrow-right-down', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }, _react.default.createElement("g", {
    transform: "translate(10.000000, 11.000000)",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("g", {
    transform: "translate(0.275537, 0.000000)"
  }, _react.default.createElement("polyline", {
    transform: "translate(17.724463, 17.000000) rotate(90.000000) translate(-17.724463, -17.000000) ",
    points: "8.72446285 8 26.7244629 8 26.7244629 26"
  }), _react.default.createElement("path", {
    d: "M31.9930816,13.6249513 L-4,12.9192046",
    transform: "translate(13.996541, 13.272078) rotate(223.876697) translate(-13.996541, -13.272078) "
  })))));
});

exports.default = _default;